
(function(){
/* ---------------------------------------------------------------------------
MAKLIN NEW BIKE INTAKE \u2014 single page.
Gathers info and emails it. No scoring, no routing, no assignment \u2014
the shop reads the inquiry and decides who takes it.
--------------------------------------------------------------------------- */
const FAMILIES = [
{ id:'road', name:'Road', desc:'Pavement \u2014 group rides, climbing, going fast.', subs:[
{ id:'road-allround', name:'All-around race' },
{ id:'road-climb', name:'Lightweight / climbing' },
{ id:'road-aero', name:'Aero race' },
{ id:'road-endur', name:'Endurance' },
{ id:'road-e', name:'E-road' },
]},
{ id:'gravel', name:'Gravel', desc:'Mixed surface, dirt roads, long days.', subs:[
{ id:'gr-race', name:'Race gravel' },
{ id:'gr-fast', name:'Fast / smooth gravel' },
{ id:'gr-adv', name:'Adventure / rough gravel' },
{ id:'gr-onebike', name:'Do-it-all one bike' },
{ id:'gr-pack', name:'Bikepacking / loaded touring' },
{ id:'gr-e', name:'E-gravel' },
]},
{ id:'mtb', name:'Mountain', desc:'Singletrack and trail.', subs:[
{ id:'mtb-ht', name:'Hardtail' },
{ id:'mtb-xc', name:'XC race' },
{ id:'mtb-dc', name:'Downcountry' },
{ id:'mtb-tr', name:'Trail / full suspension' },
{ id:'mtb-e', name:'E-MTB' },
]},
{ id:'tt', name:'Time Trial / Triathlon', desc:'Racing the clock \u2014 TT bikes and tri bikes.', subs:[
{ id:'tt-tri', name:'Triathlon' },
{ id:'tt-tt', name:'Time trial' },
]},
{ id:'fat', name:'Fat Bike', desc:'Snow, sand, and winter singletrack.', subs:[
{ id:'fat-winter', name:'Winter trail / snow' },
{ id:'fat-allseason', name:'All-season do-anything' },
]},
{ id:'unsure', name:"Not sure yet \u2014 help me work it out", desc:"Tell us where you ride and we'll narrow it down together.", subs:[] },
];
const BRANDS = [
'Moots','TIME','Ritchey','Soma','Cerv\u00e9lo','Santa Cruz','Bianchi','Salsa','Jamis',
"Something you don't carry",'No idea yet',
];
const MATERIALS = ['Aluminum','Steel','Titanium','Carbon'];
const DEPTHS = [
{ id:'none', name:"Not much \u2014 tell me what's right", desc:"We'll spec it around how you ride.", core:false, detail:false },
{ id:'some', name:'I have some preferences', desc:'A few things you know you want.', core:true, detail:false },
{ id:'all', name:'Very \u2014 I know what I want', desc:'Give us the spec sheet.', core:true, detail:true },
];
const CORE_SPEC = [
{ id:'group', label:'Groupset preference', opts:['Shimano','SRAM','Campagnolo','No preference'] },
{ id:'level', label:'Component level', opts:['105 / Rival / GRX 610','Ultegra / Force / GRX 820','Dura-Ace / Red / XTR / XX SL','Not sure \u2014 advise me'],
note:"Where you'd like to start. Nothing below this is worth building on." },
{ id:'shift', label:'Shifting', opts:['Mechanical','Electronic (Di2 / AXS)','No preference'] },
{ id:'drive', label:'Drivetrain', opts:['1x','2x','No preference'], note:'1x is simpler; 2x gives tighter gear steps and more range.' },
{ id:'bar', label:'Handlebar', opts:['Drop bar','Flat bar','Either'] },
];
const DETAIL_SPEC = [
{ id:'gearing', label:'Gearing bias', opts:['Easier climbing gears','Top-end speed','Balanced','No preference'] },
{ id:'wheelmat', label:'Wheels', opts:['Carbon','Alloy','I have wheels to use','No preference'] },
{ id:'brake', label:'Brakes', opts:['Disc','Rim','No preference'] },
{ id:'tubeless', label:'Tubeless setup', opts:['Yes','No','Not sure'] },
{ id:'power', label:'Power meter', opts:['Want one on the build','Already have one','No','Maybe'] },
];
const TOUCH_SPEC = [
{ id:'pedals', label:'Pedals', opts:['Clipless \u2014 keeping mine','Clipless \u2014 need new','Flat pedals','Not sure'] },
{ id:'pedalsys', label:'Which pedal system?', opts:['Shimano SPD-SL','Shimano SPD','Look Keo','Speedplay','Crankbrothers','Time','Flat / no clip','Not sure'] },
{ id:'saddle', label:'Saddle', opts:['Bringing my own','Need help finding one','Whatever comes on it'] },
{ id:'hands', label:'Hand comfort', opts:['No issues','Numbness or hot spots','Wrist or shoulder pain'] },
];
const TERRAIN = ['Paved roads','Paved trails / greenways','Gravel roads','Chunky / adventure gravel','Singletrack','Groomed doubletrack','Group rides','Commuting','Bikepacking / touring','Indoor trainer','Winter / fat riding'];
const GOALS = ['Just like riding bikes','Gran fondo / century','Gravel race (Unbound, Filthy 50, etc.)','Road racing / crits','MTB racing','Bikepacking trip','Weight loss / fitness','Riding with family','Keeping up on group rides','Touring / vacation riding'];
/* Single-pick chip rows: [ stateKey, containerId, options ] */
const SINGLE_CHIPS = [
['replacing','replacing-chips', ['Replacing my current bike','Adding to what I have','First bike / getting back into it','Buying for someone else']],
['clearance','clearance-chips', ['Up to 32 mm','Up to 40 mm','Up to 45 mm','Up to 50 mm','Up to 57 mm (2.25")','Up to 2.6"','3.8"+','Not sure \u2014 advise me']],
['buildtype','buildtype-chips', ['Stock bike, ready to ride','Stock bike with part swaps or upgrades','Custom frame-up build','Not sure \u2014 talk me through it']],
['tradein','trade-chips', ['Yes','Maybe','No']],
['tradecond','tradecond-chips', ['Excellent','Good','Well used','Not sure']],
['tradeintent','tradeintent-chips', ['Trade toward the new one','Sell it outright','Either works']],
['timeline','timeline-chips', ['Ready now','Before spring','No timeline, just seeing what\u2019s out there']],
['years','years-chips', ['Brand new to it','Under 2 years','2\u20135 years','5\u201310 years','10\u201320 years','20+ years','Getting back into it']],
['weekly','weekly-chips', ['Under 25 mi','25\u201350 mi','50\u2013100 mi','100\u2013150 mi','150\u2013250 mi','250+ mi']],
['season','season-chips', ['Year-round, outside','Year-round, indoor in winter','Spring through fall','Summer mostly','Weekends and vacations']],
['known','known-chips', ['First time','Been in before','Service customer','Bought a bike from us','Follow the YouTube channel']],
['format','format-chips', ['Come in \u2014 book me a time','Phone call first',"Either \u2014 whatever's faster"]],
['visit','visit-chips', ['ASAP','Next week','Next few weeks','Flexible']],
];
const SHOP_DAYS = ['Monday','Tuesday','Thursday','Friday','Sunday'];
const CALL_WINDOWS = ['Mornings','Afternoons','Weekends','Anytime'];
/* ---------------------------------------------------------------------------
EMAILJS \u2014 customer receipt. Only fires after Formspree confirms the
inquiry was actually received, so nobody gets a receipt for a lost lead.
--------------------------------------------------------------------------- */
const EMAILJS = {
publicKey: 'w_HC_PCD2NltmqT3p',
serviceId: 'service_u16e3f5',
templateId: 'NewBikeInquiry_cwimp9e',
};
function sendReceipt(toEmail, firstName, refNum, rows){
if(!window.emailjs) return;
const text = rows.map(r => r[0] + ': ' + r[1]).join('\n');
const html = rows.map(r =>
'<tr><td style="padding:7px 14px 7px 0;color:#726A5C;font-size:13px;white-space:nowrap;vertical-align:top;border-bottom:1px solid #E6DFD0">' +
r[0] + '</td><td style="padding:7px 0;color:#1F1C17;font-size:14px;border-bottom:1px solid #E6DFD0">' +
r[1] + '</td></tr>').join('');
try {
emailjs.init({ publicKey: EMAILJS.publicKey });
emailjs.send(EMAILJS.serviceId, EMAILJS.templateId, {
to_email: toEmail,
customer_name: firstName,
ref_number: refNum,
summary_text: text,
summary_html: html,
}).catch(()=>{});
} catch(e){ /* receipt is best-effort \u2014 never blocks anything */ }
}
/* --- STATE --- */
let selFamily=null, selSub=null, selDepth=null;
let selTerrain={}, selGoals={}, selBrands={}, selMaterials={}, selCall={}, selDays={}, spec={}, touch={}, single={};
let currentBikes=[], pastBikes=[];
/* --- RENDERERS --- */
function tileMark(){
return '<div class="tile-mark"><svg viewBox="0 0 11 9" fill="none"><polyline points="1,4.5 4,7.5 10,1" stroke="#FFFDF7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></div>';
}
function renderTiles(containerId, items, isSel, onPick, multi){
const c = document.getElementById(containerId);
if(!c) return;
c.innerHTML = '';
items.forEach(item => {
const el = document.createElement('div');
el.className = 'tile' + (multi ? ' multi' : '') + (isSel(item) ? ' sel' : '');
el.tabIndex = 0;
el.innerHTML = tileMark() +
`<div class="tile-info"><div class="tile-name">${item.name}</div>${item.desc?`<div class="tile-desc">${item.desc}</div>`:''}</div>`;
const pick = () => { onPick(item); renderAll(); };
el.onclick = pick;
el.onkeydown = e => { if(e.key==='Enter'||e.key===' '){ e.preventDefault(); pick(); } };
c.appendChild(el);
});
}
function renderChips(containerId, list, store){
const c = document.getElementById(containerId);
if(!c) return;
c.innerHTML = '';
list.forEach(name => {
const b = document.createElement('button');
b.type='button';
b.className = 'chip' + (store[name] ? ' sel' : '');
b.textContent = name;
b.onclick = () => { store[name] ? delete store[name] : store[name]=true; renderChips(containerId,list,store); };
c.appendChild(b);
});
}
function renderChipsOne(key, containerId, list){
const c = document.getElementById(containerId);
if(!c) return;
c.innerHTML = '';
list.forEach(name => {
const b = document.createElement('button');
b.type='button';
b.className = 'chip' + (single[key]===name ? ' sel' : '');
b.textContent = name;
b.onclick = () => { single[key] = (single[key]===name) ? '' : name; renderChipsOne(key, containerId, list); updateReveals(); };
c.appendChild(b);
});
}
function updateReveals(){
const t = document.getElementById('trade-block');
if(t) t.classList.toggle('hidden', !(single.tradein === 'Yes' || single.tradein === 'Maybe'));
}
/* Family tiles with sub-chips dropping in directly beneath the picked tile. */
function placeRidingBlock(){
const block = document.getElementById('riding-block');
const hd = block.querySelector('.riding-hd');
const sub = block.querySelector('.riding-sub');
const fam = document.getElementById('fam-list');
const unsure = selFamily === 'unsure';
if(unsure){
// sits inline under the "Not sure" tile, and it's the required path
block.classList.remove('standalone');
block.classList.add('reveal-inline');
hd.textContent = 'Where do you want to ride?';
sub.textContent = 'Pick everything that applies \u2014 including riding you want to be doing, not just what you do now. This is how we narrow it down.';
fam.appendChild(block);
} else {
// optional context for someone who already knows what they want
block.classList.remove('reveal-inline');
block.classList.add('standalone');
hd.textContent = 'Where do you ride?';
sub.textContent = 'Optional \u2014 but it changes tire clearance, gearing and geometry more than the category does.';
document.getElementById('sec-bike').appendChild(block);
}
}
function renderFamilies(){
const c = document.getElementById('fam-list');
const block = document.getElementById('riding-block');
document.getElementById('riding-stash').appendChild(block);
c.innerHTML = '';
FAMILIES.forEach(fam => {
const el = document.createElement('div');
el.className = 'tile' + (selFamily===fam.id ? ' sel' : '');
el.tabIndex = 0;
el.innerHTML = tileMark() +
`<div class="tile-info"><div class="tile-name">${fam.name}</div>${fam.desc?`<div class="tile-desc">${fam.desc}</div>`:''}</div>`;
const pick = () => {
if(selFamily !== fam.id){ selFamily = fam.id; selSub = null; }
else { selFamily = null; selSub = null; }
renderFamilies();
};
el.onclick = pick;
el.onkeydown = e => { if(e.key==='Enter'||e.key===' '){ e.preventDefault(); pick(); } };
c.appendChild(el);
if(selFamily===fam.id && fam.subs.length){
const wrap = document.createElement('div');
wrap.className = 'sub-inline';
wrap.innerHTML = `<div class="sub-lbl">${fam.name} \u2014 which kind?</div><div class="chips"></div>`;
const chips = wrap.querySelector('.chips');
fam.subs.forEach(sub => {
const b = document.createElement('button');
b.type='button';
b.className = 'chip' + (selSub===sub.id ? ' sel' : '');
b.textContent = sub.name;
b.onclick = () => { selSub = (selSub===sub.id) ? null : sub.id; renderFamilies(); };
chips.appendChild(b);
});
c.appendChild(wrap);
}
});
}
/* Depth tiles; spec blocks reveal directly beneath the tile that was picked. */
function renderDepth(){
const c = document.getElementById('depth-list');
const stash = document.getElementById('spec-stash');
const core = document.getElementById('spec-core');
const detail = document.getElementById('spec-detail');
stash.appendChild(core); stash.appendChild(detail);
core.classList.add('hidden'); detail.classList.add('hidden');
c.innerHTML = '';
DEPTHS.forEach(d => {
const el = document.createElement('div');
el.className = 'tile' + (selDepth===d.id ? ' sel' : '');
el.tabIndex = 0;
el.innerHTML = tileMark() +
`<div class="tile-info"><div class="tile-name">${d.name}</div>${d.desc?`<div class="tile-desc">${d.desc}</div>`:''}</div>`;
const pick = () => { selDepth = (selDepth===d.id) ? null : d.id; renderDepth(); };
el.onclick = pick;
el.onkeydown = e => { if(e.key==='Enter'||e.key===' '){ e.preventDefault(); pick(); } };
c.appendChild(el);
if(selDepth===d.id){
if(d.core){ core.classList.remove('hidden'); c.appendChild(core); }
if(d.detail){ detail.classList.remove('hidden'); c.appendChild(detail); }
}
});
}
function renderSeg(containerId, fields, store){
const c = document.getElementById(containerId);
if(!c) return;
c.innerHTML = '';
fields.forEach(f => {
const wrap = document.createElement('div');
wrap.innerHTML = `<label>${f.label}</label><div class="seg"></div>${f.note?`<div class="spec-note">${f.note}</div>`:''}`;
const seg = wrap.querySelector('.seg');
f.opts.forEach(o => {
const b = document.createElement('button');
b.type='button';
b.className = store[f.id]===o ? 'sel' : '';
b.textContent = o;
b.onclick = () => { store[f.id] = (store[f.id]===o) ? undefined : o; renderSeg(containerId, fields, store); };
seg.appendChild(b);
});
c.appendChild(wrap);
});
}
/* --- BIKE REPEATERS --- */
const BIKE_USE = ['Primary bike','Backup / second bike','Trainer bike','Commuter','Kept for sentimental reasons'];
function addBike(kind){ (kind==='current'?currentBikes:pastBikes).push({bike:'',use:''}); renderBikes(kind); }
function delBike(kind,i){ (kind==='current'?currentBikes:pastBikes).splice(i,1); renderBikes(kind); }
function renderBikes(kind){
const arr = kind==='current' ? currentBikes : pastBikes;
const c = document.getElementById(kind==='current' ? 'current-bikes' : 'past-bikes');
c.innerHTML = '';
if(!arr.length){
const p = document.createElement('div');
p.className='rep-empty';
p.textContent = kind==='current' ? 'Nothing added yet.' : 'Optional \u2014 add any that shaped what you want next.';
c.appendChild(p); return;
}
arr.forEach((b,i) => {
const row = document.createElement('div');
row.className='rep-row';
row.innerHTML = `
<div class="rep-fields">
<input type="text" placeholder="Year, brand and model" value="${b.bike}" data-f="bike">
${kind==='current' ? `<div><select data-f="use">
<option value="">What's it used for?</option>
${BIKE_USE.map(u=>`<option ${b.use===u?'selected':''}>${u}</option>`).join('')}
</select></div>` : ''}
</div>
<button class="rep-del" title="Remove">&times;</button>`;
row.querySelectorAll('[data-f]').forEach(el => { el.oninput = el.onchange = () => { arr[i][el.dataset.f] = el.value; }; });
row.querySelector('.rep-del').onclick = () => delBike(kind,i);
c.appendChild(row);
});
}
/* --- RENDER ALL --- */
function renderAll(){
renderFamilies();
renderDepth();
}
/* --- FIELD VALIDATION --- */
function showErr(id, msg){
const box = document.getElementById('err-' + id);
const el = document.getElementById(id);
if(box){ box.textContent = msg; box.classList.add('show'); }
el.classList.add('err');
el.scrollIntoView({behavior:'smooth', block:'center'});
el.focus({preventScroll:true});
}
function clearErr(id){
const box = document.getElementById('err-' + id);
if(box) box.classList.remove('show');
document.getElementById(id).classList.remove('err');
}
const digits = v => (v||'').replace(/\D/g,'');
function validEmail(v){ return /^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(v); }
function validPhone(v){
const d = digits(v);
return d.length === 10 || (d.length === 11 && d[0] === '1');
}
function formatPhone(v){
let d = digits(v);
if(d.length === 11 && d[0] === '1') d = d.slice(1);
d = d.slice(0,10);
if(d.length <= 3) return d;
if(d.length <= 6) return '(' + d.slice(0,3) + ') ' + d.slice(3);
return '(' + d.slice(0,3) + ') ' + d.slice(3,6) + '-' + d.slice(6);
}
/* --- SUBMIT --- */
function flagErr(id){
const el = document.getElementById(id);
el.classList.add('err');
el.scrollIntoView({behavior:'smooth', block:'center'});
setTimeout(()=>el.classList.remove('err'), 2500);
}
function submitInquiry(){
const v = id => (document.getElementById(id).value || '').trim();
if(!selFamily){
alert('Pick what you\'re after \u2014 or take "Not sure yet" and we\'ll work it out.');
document.getElementById('fam-list').scrollIntoView({behavior:'smooth', block:'center'});
return;
}
if(selFamily === 'unsure' && !Object.keys(selTerrain).length){
alert('Tell us where you want to ride \u2014 pick at least one.');
document.getElementById('terrain-chips').scrollIntoView({behavior:'smooth', block:'center'});
return;
}
if(!v('fname')){ flagErr('fname'); alert('Enter your first name.'); return; }
if(!v('lname')){ flagErr('lname'); alert('Enter your last name.'); return; }
clearErr('email'); clearErr('phone');
if(!v('email')){ showErr('email', 'We need an email to get back to you.'); return; }
if(!validEmail(v('email'))){ showErr('email', "That doesn't look like a complete email address \u2014 check for a typo."); return; }
const wantsCall = single.format === 'Phone call first' || single.format === "Either \u2014 whatever's faster";
if(wantsCall && !v('phone')){
showErr('phone', 'You asked us to call \u2014 we\'ll need a number.');
return;
}
if(v('phone') && !validPhone(v('phone'))){
showErr('phone', 'That looks like it\'s missing a digit or two.');
return;
}
const num = 'MB-N-' + Math.floor(1000 + Math.random()*9000);
const fn=v('fname'), ln=v('lname'), em=v('email'), ph=v('phone'), city=v('city');
const ht=v('height'), fi=v('fitissues'), cs=v('considering'), sw=v('sawit');
const nt=v('notes'), tb=v('tradebike'), spn=v('specnotes'), co=v('carryover'), sd=v('saddlenow');
const fam = FAMILIES.find(f=>f.id===selFamily) || {};
const sub = (fam.subs||[]).find(x=>x.id===selSub);
const catName = fam.name ? (sub ? fam.name + ' \u2014 ' + sub.name : fam.name) : '';
const depth = (DEPTHS.find(d=>d.id===selDepth)||{}).name || 'Not answered';
const brandList = Object.keys(selBrands);
const terrList = Object.keys(selTerrain);
const goalList = Object.keys(selGoals);
const matList = Object.keys(selMaterials);
const callList = Object.keys(selCall);
const dayList = Object.keys(selDays);
const specList = [...CORE_SPEC, ...DETAIL_SPEC].filter(f=>spec[f.id]).map(f=>`${f.label}: ${spec[f.id]}`);
const touchList = TOUCH_SPEC.filter(f=>touch[f.id]).map(f=>`${f.label}: ${touch[f.id]}`);
const sizing = ht ? 'Height ' + ht : '';
const fmtBike = b => [b.bike,b.use].filter(Boolean).join(' \u00b7 ');
const curList = currentBikes.map(fmtBike).filter(Boolean);
const pastList = pastBikes.map(fmtBike).filter(Boolean);
/* Confirmation \u2014 customer-facing, no routing shown */
const row = (k,val) => val ? `<div class="cd-row"><span class="cd-key">${k}</span><span class="cd-val">${val}</span></div>` : '';
document.getElementById('conf-num').textContent = num;
document.getElementById('conf-detail').innerHTML =
row('Name', fn+' '+ln) + row('Email', em) + row('Phone', ph) +
row('Looking for', catName) + row('Timeline', single.timeline) +
row('Shortlist', [brandList.join(', '), cs].filter(Boolean).join(' \u2014 ')) + row('Build type', single.buildtype) + row('Trade-in', single.tradein==='No'?'':[single.tradein, tb, single.tradeintent].filter(Boolean).join(' \u2014 ')) + row('Tire clearance', single.clearance) + row('Frame material', matList.join(', ')) +
row('Best times', callList.join(', ')) + row('Coming in', single.visit) + row('Days that work', dayList.join(', '));
/* Payload */
const set = (id,val) => document.getElementById(id).value = val;
set('fs_num', num);
set('fs_name', fn+' '+ln); set('fs_email', em); set('fs_replyto', em);
set('fs_phone', ph||'Not provided'); set('fs_city', city||'Not provided');
set('fs_known', single.known||'Not answered');
set('fs_cat', catName); set('fs_replacing', single.replacing||'Not answered');
set('fs_brands', brandList.join(', ')||'None picked');
set('fs_considering', cs||'Not provided'); set('fs_buildtype', single.buildtype||'Not answered'); set('fs_sawit', sw||'Not provided');
set('fs_timeline', single.timeline||'Not answered');
set('fs_years', single.years||'Not answered'); set('fs_weekly', single.weekly||'Not answered');
set('fs_season', single.season||'Not answered');
set('fs_terrain', terrList.join(', ')||'Not answered'); set('fs_goals', goalList.join(', ')||'Not answered');
set('fs_current', curList.join(' | ')||'None listed'); set('fs_past', pastList.join(' | ')||'None listed');
set('fs_depth', depth); set('fs_spec', specList.join(' | ')||'No preferences given');
set('fs_clearance', single.clearance||'Not answered'); set('fs_materials', matList.join(', ')||'Not answered'); set('fs_specnotes', spn||'None');
set('fs_touch', touchList.join(' | ')||'Not answered'); set('fs_saddle', sd||'Not provided'); set('fs_carryover', co||'None');
set('fs_size', sizing||'Not provided'); set('fs_fit', fi||'None noted');
set('fs_format', single.format||'Not answered');
set('fs_call', callList.join(', ')||'Not answered'); set('fs_visit', single.visit||'Not answered'); set('fs_days', dayList.join(', ')||'Not answered');
set('fs_newsletter', document.getElementById('newsletter').checked ? 'YES \u2014 add to list' : 'No');
set('fs_trade', single.tradein||'Not answered');
set('fs_tradebike', tb||'Not provided');
set('fs_tradecond', single.tradecond||'Not answered');
set('fs_tradeintent', single.tradeintent||'Not answered');
set('fs_notes', nt||'None');
set('fs_subject', `New bike inquiry ${num} \u2014 ${fn} ${ln} \u2014 ${catName}`);
const receiptRows = [
['Looking for', catName],
['Tire clearance', single.clearance],
['Frame material', matList.join(', ')],
['Build type', single.buildtype],
['Timeline', single.timeline],
['Shortlist', [brandList.join(', '), cs].filter(Boolean).join(' \u2014 ')],
['Where you ride', terrList.join(', ')],
['Riding toward', goalList.join(', ')],
['Trade-in', single.tradein === 'No' ? '' : [single.tradein, tb, single.tradecond, single.tradeintent].filter(Boolean).join(' \u2014 ')],
['Riding now', [single.years, single.weekly, single.season].filter(Boolean).join(' \u00b7 ')],
['Bikes owned', curList.join('; ')],
['Component preferences', specList.join('; ')],
['Contact points', touchList.join('; ')],
['Height', ht],
['Fit notes', fi],
['How to start', single.format],
['Good times to reach you', callList.join(', ')],
['Could come in', single.visit],
['Days that work', dayList.join(', ')],
['Your notes', nt],
].filter(r => r[1]);
const form = document.getElementById('fsform');
const btn = document.getElementById('submit-btn');
const fail = document.getElementById('send-fail');
fail.classList.add('hidden');
btn.disabled = true;
btn.textContent = 'Sending\u2026';
fetch(form.action, {
method: 'POST',
body: new FormData(form),
headers: { 'Accept': 'application/json' }
})
.then(res => {
if(!res.ok) throw new Error('rejected');
sendReceipt(em, fn, num, receiptRows);
document.getElementById('form-view').classList.add('hidden');
document.getElementById('conf-view').classList.remove('hidden');
document.getElementById('mk-nb').scrollIntoView({behavior:'smooth', block:'start'});
})
.catch(() => {
btn.disabled = false;
btn.textContent = 'Send my inquiry';
fail.classList.remove('hidden');
fail.scrollIntoView({ behavior:'smooth', block:'center' });
});
}
/* --- OPTIONAL DEPTH TOGGLE --- */
function mkMore(){
const b = document.getElementById('more-block');
const t = document.getElementById('more-btn');
const open = b.classList.toggle('hidden') === false;
t.classList.toggle('open', open);
t.querySelector('.more-caret').textContent = open ? '\u2212' : '+';
if(open) b.scrollIntoView({behavior:'smooth', block:'start'});
}
/* --- INIT --- */
(function init(){
const ph = document.getElementById('phone');
ph.addEventListener('input', () => { ph.value = formatPhone(ph.value); clearErr('phone'); });
document.getElementById('email').addEventListener('input', () => clearErr('email'));
renderAll();
renderChips('brand-chips', BRANDS, selBrands);
renderChips('terrain-chips', TERRAIN, selTerrain);
renderChips('goal-chips', GOALS, selGoals);
renderChips('material-chips', MATERIALS, selMaterials);
renderChips('call-chips', CALL_WINDOWS, selCall);
renderChips('days-chips', SHOP_DAYS, selDays);
SINGLE_CHIPS.forEach(([k,id,list]) => renderChipsOne(k, id, list));
renderSeg('core-fields', CORE_SPEC, spec);
renderSeg('detail-fields', DETAIL_SPEC, spec);
renderSeg('touch-fields', TOUCH_SPEC, touch);
renderBikes('current'); renderBikes('past');
updateReveals();
addBike('current');
})();
window.mkNB = { addBike: addBike, submit: submitInquiry, more: mkMore };
})();

/* mk-config-prefill: configurator hands its build summary to the notes field */
try{var _mkb=new URLSearchParams(location.search).get('build');if(_mkb){var _mkn=document.getElementById('notes');if(_mkn&&!_mkn.value){_mkn.value=_mkb;}}}catch(e){}
